import getApi from '../../api'
import { RecipientSuggestion } from '../../model/RecipientSuggestion'

export const getRecipientSuggestion = (search: string, patientId?: number, signal?: AbortSignal) =>
  getApi().get<RecipientSuggestion>(`/mss/recipient_suggestions`, { search, patientId }, { signal })
